// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./style_constants.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agens-tab-contaienr {
    .statistics-report {
        display: flex;
        justify-content: space-around;
    }

    .cpu-menu-icon {
        margin-right: 3%;
        padding-top: 3px;
        font-size: 17px;
    }

    .agents-chart-container {
        margin-top: 2%;
    }

    .graph-icon {
        margin-top: 5px;
        font-size: 30px;
        padding: 2px;
    }

    .agent-details-container {
        height: calc(100vh - 73px);
        overflow-y: auto;
    }

    .task-table-container {
        margin-top: 0%;

        .edit-delete-table-cell {
            width: 50px;
            text-align: center;
            padding-left: 0px;
            padding-right: 30px !important;

        }
        .agent-controller{
            width: 74px;
            border: none;
            border-radius: 15px;
            background: #1976d2;
            padding: 3px 0px;
            color: white;
            font-size: 0.9rem;
            margin-right: 10px;
            cursor: pointer;
        }
        .task-cancel-button{
            width: 74px;
            border: none;
            border-radius: 15px;
            background: #d21919;
            padding: 3px 0px;
            color: white;
            font-size: 0.9rem;
            margin-left: 10px;
            cursor: pointer;

        }
        .disabled-button{
            cursor: not-allowed;
            opacity: 0.5;
        }
        .controller-cell{
            min-width: 225px;
        }
    }

    .MuiTableCell-sizeMedium {
        padding: 0px !important;
        padding-left: 16px !important;
        font-style: none;
    }

    .user_req_dropdown {
        padding: 0px !important;
        background: #1976d2;
        color: white;
    }

    .current-running-job {
        background-color: aliceblue;
    }

    .empty-data {
        text-align: center;
    }

    .tasks-header {
        font-weight: bold;
        text-align: center;
    }


}


.agents-detail-container {
    margin-top: 1%;

    .agent-details {
        margin-top: 10px;
        padding: 20px;
    }

    .MuiTypography-root {
        font-size: 0.9rem !important;
    }

    .MuiPaper-elevation {
        width: 95% !important;
        padding: 15px;

    }
}

.task-modal-cotainer {
    .modal-box-container {
        width: 60%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: white;
        padding: 16px;
        box-shadow: 24px 24px 24px rgba(0, 0, 0, 0.2);
        max-height: 90%;
        overflow-y: auto;
    }

    .styled-input {
        width: 90%;
        font-family: var(--font-family);
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 1.5;
        padding: 8px 12px;
        border-radius: 8px;
        color: var(--input-text-color, #1a1a1a);
        background: var(--input-bg-color, #fff);
        border: 1px solid var(--input-border-color, #ddd);
        box-shadow: 0 2px 2px var(--input-shadow-color, #f2f2f2);
        transition: border-color 0.2s, box-shadow 0.2s;
        height: 39px;
    }

    .styled-text-area {
        resize: none;
        height: 90px;
    }

    .styled-input:hover {
        border-color: #1e88e5;
        /* Blue */
    }

    .styled-input:focus {
        outline: none;
        border-color: #1e88e5;
        box-shadow: 0 0 0 3px rgba(30, 136, 229, 0.3);
        /* Light blue glow */
    }

    .modal-labels {
        width: 45%;
    }

    .input-fields-box {
        width: 48%;
        float: left;
    }

    .text-area-input-fields-box {
        width: 100%;
        margin-left: 1%;
        float: left;
    }
    
    

    .error-message-container {
        position: fixed; /* or absolute */
        top: 10px; /* Adjust as needed */
        left: 50%;
        transform: translateX(-50%);
        z-index: 9999; /* Ensure it's on top */
        padding: 10px 20px;
        border-radius: 5px;
    }
    
    .alert-message {
        display: inline-block;
        font-size: 14px;
        font-weight: bold;
        padding: 9px 41px;
        border-radius: 5px;
    }
    
    .error-message {
        background-color: #fee2e2;
        color: #b91c1c;
    }
    
    .success-message {

        background-color: #d1fae5;
        color: #047857;
    }
    
    .info-message {
         background-color: #bfdbfe;
        color: #1d4ed8;
    }
    

    .submit-button-container {
        width: 100%;
        float: inline-end;
        text-align: center;
        margin-top: 2%;
    }

    .modal-close-button {
        margin-top: -2rem;
        font-size: 1.5rem;
        margin-right: -0.6rem;
        color: black;
        cursor: pointer;
    }

    /* .close-task-modal-button{
        font-size: 1.4rem;
        margin-right: -2rem;
        margin-top: -2rem;
        color: black;
      } */

}
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }`, "",{"version":3,"sources":["webpack://./src/assets/styles/agents.css"],"names":[],"mappings":"AACA;IACI;QACI,aAAa;QACb,6BAA6B;IACjC;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;IACpB;;IAEA;QACI,cAAc;;QAEd;YACI,WAAW;YACX,kBAAkB;YAClB,iBAAiB;YACjB,8BAA8B;;QAElC;QACA;YACI,WAAW;YACX,YAAY;YACZ,mBAAmB;YACnB,mBAAmB;YACnB,gBAAgB;YAChB,YAAY;YACZ,iBAAiB;YACjB,kBAAkB;YAClB,eAAe;QACnB;QACA;YACI,WAAW;YACX,YAAY;YACZ,mBAAmB;YACnB,mBAAmB;YACnB,gBAAgB;YAChB,YAAY;YACZ,iBAAiB;YACjB,iBAAiB;YACjB,eAAe;;QAEnB;QACA;YACI,mBAAmB;YACnB,YAAY;QAChB;QACA;YACI,gBAAgB;QACpB;IACJ;;IAEA;QACI,uBAAuB;QACvB,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;;AAGJ;;;AAGA;IACI,cAAc;;IAEd;QACI,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;QACrB,aAAa;;IAEjB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gCAAgC;QAChC,uBAAuB;QACvB,aAAa;QACb,6CAA6C;QAC7C,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,+BAA+B;QAC/B,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,uCAAuC;QACvC,uCAAuC;QACvC,iDAAiD;QACjD,wDAAwD;QACxD,8CAA8C;QAC9C,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,qBAAqB;QACrB,6CAA6C;QAC7C,oBAAoB;IACxB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,WAAW;QACX,eAAe;QACf,WAAW;IACf;;;;IAIA;QACI,eAAe,EAAE,gBAAgB;QACjC,SAAS,EAAE,qBAAqB;QAChC,SAAS;QACT,2BAA2B;QAC3B,aAAa,EAAE,uBAAuB;QACtC,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,eAAe;QACf,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;;QAEI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;SACK,yBAAyB;QAC1B,cAAc;IAClB;;;IAGA;QACI,WAAW;QACX,iBAAiB;QACjB,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,qBAAqB;QACrB,YAAY;QACZ,eAAe;IACnB;;IAEA;;;;;SAKK;;AAET;AACA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC","sourcesContent":["@import \"./style_constants.css\";\n.agens-tab-contaienr {\n    .statistics-report {\n        display: flex;\n        justify-content: space-around;\n    }\n\n    .cpu-menu-icon {\n        margin-right: 3%;\n        padding-top: 3px;\n        font-size: 17px;\n    }\n\n    .agents-chart-container {\n        margin-top: 2%;\n    }\n\n    .graph-icon {\n        margin-top: 5px;\n        font-size: 30px;\n        padding: 2px;\n    }\n\n    .agent-details-container {\n        height: calc(100vh - 73px);\n        overflow-y: auto;\n    }\n\n    .task-table-container {\n        margin-top: 0%;\n\n        .edit-delete-table-cell {\n            width: 50px;\n            text-align: center;\n            padding-left: 0px;\n            padding-right: 30px !important;\n\n        }\n        .agent-controller{\n            width: 74px;\n            border: none;\n            border-radius: 15px;\n            background: #1976d2;\n            padding: 3px 0px;\n            color: white;\n            font-size: 0.9rem;\n            margin-right: 10px;\n            cursor: pointer;\n        }\n        .task-cancel-button{\n            width: 74px;\n            border: none;\n            border-radius: 15px;\n            background: #d21919;\n            padding: 3px 0px;\n            color: white;\n            font-size: 0.9rem;\n            margin-left: 10px;\n            cursor: pointer;\n\n        }\n        .disabled-button{\n            cursor: not-allowed;\n            opacity: 0.5;\n        }\n        .controller-cell{\n            min-width: 225px;\n        }\n    }\n\n    .MuiTableCell-sizeMedium {\n        padding: 0px !important;\n        padding-left: 16px !important;\n        font-style: none;\n    }\n\n    .user_req_dropdown {\n        padding: 0px !important;\n        background: #1976d2;\n        color: white;\n    }\n\n    .current-running-job {\n        background-color: aliceblue;\n    }\n\n    .empty-data {\n        text-align: center;\n    }\n\n    .tasks-header {\n        font-weight: bold;\n        text-align: center;\n    }\n\n\n}\n\n\n.agents-detail-container {\n    margin-top: 1%;\n\n    .agent-details {\n        margin-top: 10px;\n        padding: 20px;\n    }\n\n    .MuiTypography-root {\n        font-size: 0.9rem !important;\n    }\n\n    .MuiPaper-elevation {\n        width: 95% !important;\n        padding: 15px;\n\n    }\n}\n\n.task-modal-cotainer {\n    .modal-box-container {\n        width: 60%;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        background-color: white;\n        padding: 16px;\n        box-shadow: 24px 24px 24px rgba(0, 0, 0, 0.2);\n        max-height: 90%;\n        overflow-y: auto;\n    }\n\n    .styled-input {\n        width: 90%;\n        font-family: var(--font-family);\n        font-size: 0.875rem;\n        font-weight: 400;\n        line-height: 1.5;\n        padding: 8px 12px;\n        border-radius: 8px;\n        color: var(--input-text-color, #1a1a1a);\n        background: var(--input-bg-color, #fff);\n        border: 1px solid var(--input-border-color, #ddd);\n        box-shadow: 0 2px 2px var(--input-shadow-color, #f2f2f2);\n        transition: border-color 0.2s, box-shadow 0.2s;\n        height: 39px;\n    }\n\n    .styled-text-area {\n        resize: none;\n        height: 90px;\n    }\n\n    .styled-input:hover {\n        border-color: #1e88e5;\n        /* Blue */\n    }\n\n    .styled-input:focus {\n        outline: none;\n        border-color: #1e88e5;\n        box-shadow: 0 0 0 3px rgba(30, 136, 229, 0.3);\n        /* Light blue glow */\n    }\n\n    .modal-labels {\n        width: 45%;\n    }\n\n    .input-fields-box {\n        width: 48%;\n        float: left;\n    }\n\n    .text-area-input-fields-box {\n        width: 100%;\n        margin-left: 1%;\n        float: left;\n    }\n    \n    \n\n    .error-message-container {\n        position: fixed; /* or absolute */\n        top: 10px; /* Adjust as needed */\n        left: 50%;\n        transform: translateX(-50%);\n        z-index: 9999; /* Ensure it's on top */\n        padding: 10px 20px;\n        border-radius: 5px;\n    }\n    \n    .alert-message {\n        display: inline-block;\n        font-size: 14px;\n        font-weight: bold;\n        padding: 9px 41px;\n        border-radius: 5px;\n    }\n    \n    .error-message {\n        background-color: #fee2e2;\n        color: #b91c1c;\n    }\n    \n    .success-message {\n\n        background-color: #d1fae5;\n        color: #047857;\n    }\n    \n    .info-message {\n         background-color: #bfdbfe;\n        color: #1d4ed8;\n    }\n    \n\n    .submit-button-container {\n        width: 100%;\n        float: inline-end;\n        text-align: center;\n        margin-top: 2%;\n    }\n\n    .modal-close-button {\n        margin-top: -2rem;\n        font-size: 1.5rem;\n        margin-right: -0.6rem;\n        color: black;\n        cursor: pointer;\n    }\n\n    /* .close-task-modal-button{\n        font-size: 1.4rem;\n        margin-right: -2rem;\n        margin-top: -2rem;\n        color: black;\n      } */\n\n}\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
